import { generatePath } from 'react-router-dom'
import { AUTOPILOT_INTEGRATIONS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Lightning, LightningFilled } from 'blaze-ui/icons'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface Props {
  onPress: () => void
}

const NavMenuAutopilotIntegrationsItem = ({ onPress }: Props) => {
  const workspaceId = useCurrentWorkspaceId()

  return (
    <NavMenuItem
      icon={Lightning}
      activeIcon={LightningFilled}
      to={generatePath(AUTOPILOT_INTEGRATIONS_PATH, { workspaceId })}
      onPress={onPress}
      label="Integrations"
    />
  )
}

export { NavMenuAutopilotIntegrationsItem }
